// Design tokens for the super-admin portal.
// Single source of truth for palette, plan/status taxonomies,
// monogram colors, shadows, and radii.

export const TOKENS = {
  // Brand
  primary: "#6371F7",
  primaryHover: "#0244BE",
  primaryInk: "#454FAD",
  primaryTint: "#EBEDF5",

  // Feedback
  success: "#1FC16B",
  successInk: "#0f7a42",
  successBg: "#E8FBEF",
  successBorder: "#B8ECD0",
  warning: "#F2B429",
  warningInk: "#7a5b10",
  warningBg: "#FFF6D0",
  warningBorder: "#FFE89A",
  danger: "#FB3748",
  dangerInk: "#A11228",
  dangerBg: "#FEECEE",
  dangerBorder: "#F7C9CF",
  dangerHover: "#D00416",
  info: "#0255ED",
  infoInk: "#0255ED",
  infoBg: "#EDF3FE",
  infoBorder: "#C7DAFB",

  // Foreground / surfaces / borders
  fg1: "#292929",
  fg2: "#7B7B7B",
  fg3: "#959595",
  fgInverse: "#FFFFFF",
  fgLink: "#0255ED",
  bgSurface: "#FFFFFF",
  bgCanvas: "#F4F4F4",
  bgSunken: "#F7F7F9",
  bgOverlay: "rgba(17,17,17,0.5)",
  border: "#D4D4D4",
  borderSubtle: "rgba(0,0,0,0.08)",
  borderStrong: "#959595",

  // Plan chip palette — licensing v2 deprecation pass trimmed this to the
  // only two surviving tenant tiers. Legacy Community/Pro/Business chips
  // are no longer issued; PlanChip falls back to Enterprise if it sees
  // one of the old strings in a historical audit row.
  plans: {
    Enterprise:      { ink: "#454FAD", bg: "#EBEDF5", border: "#CED2F2", rank: 3, seats: 999 },
    EnterpriseTrial: { ink: "#0255ED", bg: "#EDF3FE", border: "#C7DAFB", rank: 2, seats: 999 },
  },

  // Status pill palette
  statuses: {
    Active: { ink: "#0f7a42", bg: "#E8FBEF", border: "#B8ECD0", dot: "#1FC16B" },
    Trial: { ink: "#0255ED", bg: "#EDF3FE", border: "#C7DAFB", dot: "#3577F1" },
    Pending: { ink: "#7B7B7B", bg: "#F4F4F4", border: "#E0E0E0", dot: "#B0B0B0" },
    Suspended: { ink: "#7a5b10", bg: "#FFF6D0", border: "#FFE89A", dot: "#F2B429" },
    Expired: { ink: "#A11228", bg: "#FEECEE", border: "#F7C9CF", dot: "#FB3748" },
  },

  // Monogram palette (bg, ink) pairs
  monoPalette: [
    ["#EBEDF5", "#454FAD"],
    ["#EDF3FE", "#0255ED"],
    ["#E8FBEF", "#0f7a42"],
    ["#FFF6D0", "#916C19"],
    ["#FEECEE", "#A11228"],
    ["#F3E7FF", "#7A3FB8"],
    ["#E6F7F6", "#0E7C75"],
    ["#FDEFE6", "#B5500F"],
  ],

  // Shadows + radius
  shadowXs: "0 1px 2px rgba(17,17,17,0.04)",
  shadowS: "0 1px 3px rgba(17,17,17,0.06), 0 1px 2px rgba(17,17,17,0.04)",
  shadowM: "0 4px 12px rgba(17,17,17,0.06), 0 2px 4px rgba(17,17,17,0.04)",
  shadowL: "0 12px 32px rgba(17,17,17,0.08), 0 4px 8px rgba(17,17,17,0.04)",
  shadowFocus: "0 0 0 3px rgba(99,113,247,0.22)",
  radiusXs: 8,
  radiusS: 12,
  radiusM: 16,
  radiusL: 20,
};

export function monoFor(name = "") {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) >>> 0;
  return TOKENS.monoPalette[h % TOKENS.monoPalette.length];
}

export function initials(name = "") {
  const parts = name.replace(/[^A-Za-z0-9 ]/g, "").trim().split(/\s+/);
  if (parts.length === 0 || !parts[0]) return "";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return ((parts[0][0] || "") + (parts[1][0] || "")).toUpperCase();
}
